import api from './xlsxAPI';
import XLSX from 'xlsx';

const xlsxDown = param => {
	return api
		.getXlsxData({ url: param.url })
		.then(data => {
			let messageMap = {};
			if (data.header.code === 0) {
				//console.log('resultList', data.body.resultList);
				let resultList = data.body.resultList;
				let columns = param.columns;

				if (resultList?.length > 0) {
					let excelData = resultList.map((row, rowIndex) => {
						let rowObj = {};
						columns.forEach(col => {
							if (col.label && col.prop) {
								rowObj[col.label] = row[col.prop];
							}
						});

						return rowObj;
					});
					
					//console.log('excelData', excelData);
					const wb = XLSX.utils.book_new(); // 엑셀 파일 생성 (workbook)
					let ws = XLSX.utils.json_to_sheet(excelData); // 시트 생성 (worksheet) 및 데이터 삽입

					let today = new Date();
					let year = today.getFullYear(); // 년도
					let month = today.getMonth() + 1; // 월
					let date = today.getDate(); // 날짜
					let hours = today.getHours(); // 시
					let minutes = today.getMinutes(); // 분
					let seconds = today.getSeconds(); // 초

					//console.log('current date', `${year}${month}${date}_${hours}${minutes}${seconds}`);
					const title = `${year}${month}${date}_${hours}${minutes}${seconds}`;
					XLSX.utils.book_append_sheet(wb, ws, 'sheet1'); // 엑셀 파일에 시트 추가
					XLSX.writeFile(wb, `${title}.xls`); // 엑셀 다운로드
					messageMap = { message: 'Download success' };
				} else {
					messageMap = { message: 'No data' };
				}
			}
			return messageMap;
		})
		.catch(error => {
			throw error;
		});
};

export default xlsxDown;
